import React from 'react'

function FraniIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H24V24H0z"
            data-name="Rectangle 9308"
            transform="translate(305 1608)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 558" transform="translate(-305 -1608)">
        <path
          fill="#fe5f55"
          d="M9.565 10.376v8.5l7.837-8.5zM0 0v22.908l7.836-8.5V8.5h5.449L21.124 0z"
          data-name="Path 69483"
          transform="translate(306 1608.546)"
        ></path>
      </g>
    </svg>
  )
}

export default FraniIcon
